// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr;
  grid-column: auto;
}
.template-grid > div {
  border-radius: 0.5rem;
  box-shadow: 0px 0px 3px var(--accent);
  order: 2;
}
.template-grid > div > div {
  background: var(--primary);
  color: var(--white);
  padding: 1rem;
  border-radius: 0.2rem 0.2rem 0 0;
}
.template-grid > app-preview-document {
  order: 1;
}
@media (min-width: 768px) {
  .template-grid {
    grid-template-columns: 7fr 3fr;
  }
  .template-grid > div {
    order: 2;
  }
  .template-grid > app-preview-document {
    order: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/documentos/template/template.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,SAAA;EACA,0BAAA;EACA,iBAAA;AACD;AACC;EACC,qBAAA;EACA,qCAAA;EACA,QAAA;AACF;AAAE;EACC,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,gCAAA;AAEH;AAEC;EACC,QAAA;AAAF;AAGC;EAtBD;IAuBE,8BAAA;EAAA;EAEA;IACC,QAAA;EAAD;EAGA;IACC,QAAA;EADD;AACF","sourcesContent":[".template-grid {\n\tdisplay: grid;\n\tgap: 1rem;\n\tgrid-template-columns: 1fr;\n\tgrid-column: auto;\n\n\t& > div {\n\t\tborder-radius: 0.5rem;\n\t\tbox-shadow: 0px 0px 3px var(--accent);\n\t\torder: 2;\n\t\t& > div {\n\t\t\tbackground: var(--primary);\n\t\t\tcolor: var(--white);\n\t\t\tpadding: 1rem;\n\t\t\tborder-radius: 0.2rem 0.2rem 0 0;\n\t\t}\n\t}\n\n\t&>app-preview-document {\n\t\torder: 1;\n\t}\n\n\t@media (min-width: 768px) {\n\t\tgrid-template-columns: 7fr 3fr;\n\n\t\t& > div {\n\t\t\torder: 2;\n\t\t}\n\n\t\t& > app-preview-document {\n\t\t\torder: 1;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
